/**
 * A value that lags behind its input, for feeding search terms to the server.
 *
 * The Bexio list endpoints search with `lower(coalesce(col,'')) LIKE '%term%'`,
 * which no b-tree index can serve — so every request is a scan, and one request
 * per keystroke turns "RE-00061" into eight of them, each also triggering a
 * mapping-status batch when it lands. The input stays fully responsive; only the
 * request waits.
 *
 * Same shape as `useAsyncPagedSearch`'s debounce (`setTimeout` + `clearTimeout`,
 * trimmed), so the two behave alike.
 */
import { useEffect, useState } from "react";

/** Matches the delay used by the repo's other search surfaces. */
export const SEARCH_DEBOUNCE_MS = 250;

export function useDebouncedValue(value, delay = SEARCH_DEBOUNCE_MS) {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setSettled(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);

  return settled;
}

export default useDebouncedValue;
